// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"38":"5805fafd74a758e3","655":"2c28450905304c5f"}[chunkId] + ".js";
};